<template>
    <base-form @submit="onSubmit">
        <div class="px-6 pt-6 border-b">
            <h1 class="mb-3 text-lg font-normal font-semibold">
                {{ personas.length > 0 ? 'Create a new profile' : 'Welcome!' }}
            </h1>

            <template v-if="personas.length > 0">
                <p class="mb-3 text-grey-darker">Need another profile? No problem.</p>
            </template>
            <template v-else>
                <p class="mb-3 text-grey-darker">What sort of profile do you require?</p>
            </template>

            <validator-alert :sid="sid" />

            <base-alert
                v-if="!_.preload('app.beta.allow-landlords')"
                level="warning"
            >
                <template slot="heading">Paused landlord creation</template>

                <template slot="content">
                    We've placed a temporary pause on creating new landlords accounts. Apologies for the inconvenience.
                </template>
            </base-alert>

            <form-item
                :sid="sid"
                :is-required="true"
                name="persona_type"
            >
                <template slot="label">Profile Type</template>

                <div class="flex flex-col">
                    <input-radio-card
                        v-model="form.persona_type"
                        value="landlord"
                        name="persona_type"
                        class="mb-3"
                        :disabled="!_.preload('app.beta.allow-landlords')"
                    >
                        <template slot="label">Landlord</template>
                        <template slot="hint">
                            Manage properties, create tenancies, recieve rent and so on...
                        </template>
                    </input-radio-card>

                    <input-radio-card
                        v-model="form.persona_type"
                        value="tenant"
                        name="persona_type"
                    >
                        <template slot="label">Tenant</template>
                        <template slot="hint">
                            Join tenancies, pay rent and so on...
                        </template>
                    </input-radio-card>
                </div>
            </form-item>
        </div>

        <div class="px-6 py-3 text-right rounded-b bg-grey-bg">
            <base-button class="w-full btn-blue">
                Continue
            </base-button>
        </div>
    </base-form>
</template>

<script>
    import _ from 'lodash'
    import store from '../../../store'
    import * as types from '../../../store/types'
    import HeadMixin from '../../../mixins/head'
    import InputRadioCard from '../../../components/input-radio-card'

    const personas = _.get(store.getters[types.users.modules.current.getters.item], 'data.personas.data', [])

    export default {
        mixins: [
            HeadMixin
        ],
        components: {
            InputRadioCard
        },
        data () {
            return {
                sid: _.uuid(),
                form: {
                    persona_type: ''
                }
            }
        },
        computed: {
            personas () {
                return personas
            }
        },
        methods: {
            head () {
                return {
                    title: 'Create a new profile'
                }
            },
            onSubmit () {
                const personaTypes = ['landlord', 'tenant']

                if (!personaTypes.includes(this.form.persona_type)) {
                    this.$validator.set({
                        message: 'Whoops!',
                        detail: 'Please check the form for errors.',
                        errors: {
                            persona_type: [
                                !this.form.persona_type
                                    ? this.$t('validation.required', { attribute: 'profile type' })
                                    : this.$t('validation.in', { attribute: 'profile type' })
                            ]
                        }
                    }, this.sid)
                } else {
                    this.$router.push({
                        name: this.form.persona_type === 'landlord'
                            ? 'auth.landlords.create'
                            : 'auth.tenants.create',
                        query: _.get(this.$route, 'query')
                    })
                }
            }
        }
    }
</script>
